import { html } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';
import type { IHarnessToolCall } from '../interfaces.js';

const now = Date.now();

const demoCalls: IHarnessToolCall[] = [
  {
    id: 't1',
    name: 'run_command',
    status: 'completed',
    input: { command: 'pnpm test --filter ui', cwd: '/srv/app' },
    output: { exitCode: 0, stdout: '212 tests passed\n0 failed', stderr: '' },
    startedAt: now - 9200,
    finishedAt: now - 1200,
  },
  {
    id: 't2',
    name: 'run_command',
    status: 'error',
    input: { command: 'pnpm build' },
    output: { exitCode: 1, stdout: '', stderr: 'error TS2304: Cannot find name `foo`.' },
    startedAt: now - 5200,
    finishedAt: now - 4100,
  },
  {
    id: 't3',
    name: 'read_file',
    status: 'completed',
    input: { path: '/srv/app/src/config.ts', startLine: 1, endLine: 6 },
    output: "export const config = {\n  retries: 3,\n  verbose: false,\n};",
    startedAt: now - 4000,
    finishedAt: now - 3900,
  },
  {
    id: 't4',
    name: 'write_file',
    status: 'completed',
    input: {
      path: '/srv/app/src/config.ts',
      oldContent: 'export const config = {\n  retries: 3,\n  verbose: false,\n};',
      content: 'export const config = {\n  retries: 5,\n  timeoutMs: 30_000,\n  verbose: false,\n};',
    },
    startedAt: now - 3800,
    finishedAt: now - 3700,
  },
  {
    id: 't5',
    name: 'delete_file',
    status: 'running',
    input: { path: '/srv/app/tmp/cache.bin' },
    startedAt: now - 800,
  },
  {
    id: 't6',
    name: 'list_directory',
    status: 'completed',
    input: { path: 'src', recursive: false },
    output: ['index.ts', 'config.ts', 'jobs/', 'util/'],
    startedAt: now - 3000,
    finishedAt: now - 2950,
  },
  {
    id: 't7',
    name: 'browser',
    status: 'completed',
    input: { action: 'screenshot', url: 'https://example.com' },
    output: {
      screenshotBase64:
        'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==',
    },
    startedAt: now - 2500,
    finishedAt: now - 2100,
  },
  {
    id: 't8',
    name: 'http_get',
    status: 'completed',
    input: { url: 'https://api.example.com/status' },
    output: { status: 'ok', uptimeSeconds: 86_400 },
    startedAt: now - 2000,
    finishedAt: now - 1900,
  },
  {
    id: 't9',
    name: 'grep',
    status: 'completed',
    input: { pattern: 'TODO', path: 'src/' },
    output: 'src/jobs/sitemap.ts:12: // TODO pin cache key\nsrc/util/log.ts:3: // TODO levels',
    startedAt: now - 1500,
    finishedAt: now - 1400,
  },
  {
    id: 't10',
    name: 'todowrite',
    status: 'completed',
    input: {
      todos: [
        { content: 'Pin sitemap cache key', status: 'completed' },
        { content: 'Add regression test', status: 'in_progress' },
        { content: 'Deploy to staging', status: 'pending' },
      ],
    },
    startedAt: now - 1200,
    finishedAt: now - 1100,
  },
  {
    id: 't11',
    name: 'kb__lookup_article',
    status: 'completed',
    mcp: {
      serverName: 'kb',
      toolName: 'lookup_article',
      annotations: { title: 'Knowledge Lookup', readOnlyHint: true, openWorldHint: true },
    },
    input: { query: 'sitemap cache key' },
    contentBlocks: [
      { type: 'text', text: 'Found 1 article: “Deterministic sitemap builds”.' },
      {
        type: 'resource_link',
        uri: 'https://kb.example.com/articles/812',
        name: 'deterministic-sitemap-builds',
        title: 'Deterministic sitemap builds',
        mimeType: 'text/html',
      },
    ],
    startedAt: now - 900,
    finishedAt: now - 700,
  },
  {
    id: 't12',
    name: 'fleet__restart_service',
    status: 'completed',
    mcp: {
      serverName: 'fleet',
      toolName: 'restart_service',
      annotations: { destructiveHint: true, idempotentHint: true },
    },
    input: { service: 'sitemap-worker' },
    structuredContent: { restarted: true, tookMs: 3200 },
    startedAt: now - 600,
    finishedAt: now - 300,
  },
  {
    id: 't13',
    name: 'mystery_tool',
    status: 'pending',
    input: { anything: 'goes', level: 3 },
  },
  {
    // A live snapshot the producer cut to its transfer budget: the card shows a prefix and says so.
    id: 't14',
    name: 'run_command',
    status: 'running',
    input: { command: 'pnpm build --verbose', cwd: '/srv/app' },
    output: { stdout: 'compiling ts_web…\nbundling 214 modules…' },
    outputTruncated: true,
    startedAt: now - 300,
  },
];

export const demoFunc = () => demoPage('Tool activity', 'Inspect commands, changes, resources and subagent activity.', html`
  <div class="toolDemo dees-demo-stack">
    ${demoCalls.map((call) => html`<dees-harness-tool-card .call=${call}></dees-harness-tool-card>`)}
  </div>
`);
